<p-button *ngIf="visible && !disabledByEvent" class="mb-2"
    [disabled]="disabled" 
    [size]="'small'"
    [severity]="'secondary'"
    [outlined]="true"
    (onClick)="onClick()" >
    <span class="mr-2">{{label}}</span>
    <span><i [class]="iconClass" style="font-size: 1rem; font-weight: 800; color: orange;"></i></span>
</p-button>